[
  {
    "key": "none",
    "name": "None",
    "class": "bonus",
    "yields": { "food": 0, "production": 0, "gold": 0 },
    "validTerrain": [],
    "rarity": 0,
    "colour": "#00000000",
    "icon": "none",
    "description": "No resource."
  },

  {
    "_note": "Strategic resources (Phase 12b, ADR-0063) stay hidden — no icon, no yield — until their owner learns revealedBy. A unit naming one in requiresResources is built only in a city joined to it by road, river or sea, or with it traded in.",
    "key": "copper",
    "name": "Copper",
    "class": "strategic",
    "revealedBy": "bronze_working",
    "yields": { "food": 0, "production": 2, "gold": 0 },
    "validTerrain": ["hills", "desert", "plains"],
    "rarity": 0.9,
    "colour": "#B4713C",
    "icon": "ore",
    "description": "The first metal worth fighting over. Gates the earliest armed infantry."
  },
  {
    "key": "horses",
    "name": "Horses",
    "class": "strategic",
    "revealedBy": "horseback_riding",
    "yields": { "food": 1, "production": 1, "gold": 0 },
    "validTerrain": ["grassland", "plains", "tundra"],
    "rarity": 1.0,
    "colour": "#C9A227",
    "icon": "horse",
    "description": "Mobility, and the ability to punish an empire that spreads too thin."
  },
  {
    "key": "iron",
    "name": "Iron",
    "class": "strategic",
    "revealedBy": "iron_working",
    "yields": { "food": 0, "production": 2, "gold": 0 },
    "validTerrain": ["hills", "mountains", "tundra"],
    "rarity": 0.8,
    "colour": "#8C8C96",
    "icon": "ore",
    "description": "Heavy infantry and siege engines depend on it. So do wars."
  },
  {
    "key": "coal",
    "name": "Coal",
    "class": "strategic",
    "revealedBy": "steam_power",
    "yields": { "food": 0, "production": 3, "gold": 0 },
    "validTerrain": ["hills", "plains"],
    "rarity": 0.6,
    "colour": "#3A3A42",
    "icon": "ore",
    "description": "The fuel that turns workshops into industry."
  },
  {
    "key": "saltpetre",
    "name": "Saltpetre",
    "class": "strategic",
    "revealedBy": "gunpowder",
    "yields": { "food": 0, "production": 1, "gold": 1 },
    "validTerrain": ["desert", "plains", "tundra"],
    "rarity": 0.5,
    "colour": "#D8D2B8",
    "icon": "crystals",
    "description": "Unremarkable earth that ends the age of the castle."
  },

  {
    "key": "oil",
    "name": "Oil",
    "class": "strategic",
    "revealedBy": "refining",
    "yields": { "food": 0, "production": 2, "gold": 1 },
    "validTerrain": ["desert", "tundra"],
    "rarity": 0.6,
    "colour": "#2B2730",
    "icon": "oil",
    "description": "Rock oil seeping from desert sand and frozen ground: a nuisance for ages, then the fuel of engines, tanks and warships."
  },

  {
    "key": "spice",
    "name": "Spice",
    "class": "luxury",
    "yields": { "food": 0, "production": 0, "gold": 3 },
    "validTerrain": ["grassland", "plains"],
    "rarity": 0.7,
    "colour": "#B3452E",
    "icon": "spice",
    "description": "Worth more than its weight in most things, and easy to tax."
  },
  {
    "key": "silk",
    "name": "Silk",
    "class": "luxury",
    "yields": { "food": 0, "production": 0, "gold": 3 },
    "validTerrain": ["grassland", "plains"],
    "rarity": 0.6,
    "colour": "#C97BA8",
    "icon": "silk",
    "description": "A luxury that travels well and buys goodwill abroad."
  },
  {
    "key": "gemstones",
    "name": "Gemstones",
    "class": "luxury",
    "yields": { "food": 0, "production": 0, "gold": 4 },
    "validTerrain": ["hills", "mountains", "desert"],
    "rarity": 0.5,
    "colour": "#5FB8C4",
    "icon": "gem",
    "description": "Concentrated wealth, and a standing temptation to a neighbour."
  },
  {
    "key": "incense",
    "name": "Incense",
    "class": "luxury",
    "yields": { "food": 0, "production": 0, "gold": 3 },
    "validTerrain": ["desert", "plains"],
    "rarity": 0.6,
    "colour": "#D9A566",
    "icon": "incense",
    "description": "Burned in every temple that matters, and grown in almost none of them."
  },
  {
    "key": "pearls",
    "name": "Pearls",
    "class": "luxury",
    "yields": { "food": 1, "production": 0, "gold": 3 },
    "validTerrain": ["coast"],
    "rarity": 0.6,
    "colour": "#E4E1D6",
    "icon": "pearl",
    "description": "The reason a coastal city can be richer than the land behind it."
  },

  {
    "key": "wheat",
    "name": "Wheat",
    "class": "bonus",
    "yields": { "food": 2, "production": 0, "gold": 0 },
    "validTerrain": ["plains", "grassland"],
    "rarity": 1.2,
    "colour": "#E0C35C",
    "icon": "wheat",
    "description": "A surplus that becomes population."
  },
  {
    "key": "cattle",
    "name": "Cattle",
    "class": "bonus",
    "yields": { "food": 2, "production": 1, "gold": 0 },
    "validTerrain": ["grassland", "plains"],
    "rarity": 1.0,
    "colour": "#A87450",
    "icon": "cattle",
    "description": "Food and labour on the hoof."
  },
  {
    "key": "fish",
    "name": "Fish",
    "class": "bonus",
    "yields": { "food": 3, "production": 0, "gold": 0 },
    "validTerrain": ["coast", "lake"],
    "rarity": 1.2,
    "colour": "#6FC2D6",
    "icon": "fish",
    "description": "The reason so many first cities sit on water."
  },
  {
    "key": "game",
    "name": "Game",
    "class": "bonus",
    "yields": { "food": 2, "production": 0, "gold": 0 },
    "validTerrain": ["tundra", "hills", "grassland"],
    "rarity": 0.9,
    "colour": "#8F6B3F",
    "icon": "deer",
    "description": "Sustains a settlement long before it learns to farm."
  },
  {
    "key": "stone",
    "name": "Stone",
    "class": "bonus",
    "yields": { "food": 0, "production": 2, "gold": 0 },
    "validTerrain": ["hills", "desert", "tundra", "mountains"],
    "rarity": 1.0,
    "colour": "#9E9A90",
    "icon": "stone",
    "description": "Walls, roads and monuments all begin here."
  }
]
